<% var component = new Anvil.models.components.CheckList(field) %>
<div anvil-component="<%- component.id %>" class="list-group list-group-flush">
	<% for (let option of field.options) { %>
	<label for="<%= form.name %>_<%= field.name %>_<%= option.id %>" class="list-group-item list-group-item-action py-2 m-0">
		<div class="custom-control custom-checkbox">
			<input type="checkbox" class="custom-control-input" id="<%= form.name %>_<%= field.name %>_<%= option.id %>" name="<%= field.name %>_<%= option.id %>" value="<%= option.id %>" <% if (field.name in form.data && Array.isArray(form.data[field.name]) && form.data[field.name].includes(option.id)) { %>checked<% } %> />
			<label class="custom-control-label" style="pointer-events:none;" for="<%= form.name %>_<%= field.name %>_<%= option.id %>"><%- option.text %></label>
		</div>
	</label>
	<% } %>
</div>
